<div class="settings-header">
    <div class="settings-header-row">
        <div class="left">
            <div class="w-50 input-container">
                <ng-select 
                    bindLabel="name" 
                    name="name" 
                    id="orgId" 
                    [items]="regions"
                    [addTag]="false" 
                    [hideSelected]="false" 
                    [multiple]="false"
                    [closeOnSelect]="true" 
                    notFoundText="{{ 'SETTINGS.NO_ITEM_FOUND' | translate }}"
                    placeholder="{{ 'SETTINGS.REGION' | translate }}"
                    (change)="onAreaSelect($event)">
                </ng-select>
            </div>
            <div class="w-50 input-container">
                <ng-select 
                    bindLabel="name" 
                    name="name" 
                    id="orgId" 
                    [items]="organizations"
                    [addTag]="false" 
                    [hideSelected]="false" 
                    [multiple]="false"
                    [closeOnSelect]="true" 
                    notFoundText="{{ 'SETTINGS.NO_ITEM_FOUND' | translate }}"
                    placeholder="{{ 'SETTINGS.ORGANISATION' | translate }}"
                    (change)="onOrganizationSelect($event)">
                </ng-select>
            </div>
               
          
        </div>
        <div class="right">
            <button class="primary-button" (click)="openPopupArea(null)">
                {{ 'SETTINGS.NEW_AREA' | translate }}
            </button>
        </div>
    </div>
    <div class="parent-container">
        <div class="settings-list">
            <ng-container *ngFor="let region of filteredRegions; let i = index">
                <div class="row-container region-style"
                >
                    <div class="row pe-0" (click)="toggleRowDetails(i, region); $event.stopPropagation()">
                        <div class="table-column region-column col-2 ps-3">

                            <strong>{{ region?.name }}</strong>
                        </div>
                        <div class="table-column region-column col-1">
                            <span>{{ region?.orgName }}</span>
                        </div>
                        <div class="table-column region-column col-1">
                            <span class="column-label">{{ 'SETTINGS.SITES' | translate }}  {{ region.nbSites }}</span>
                        </div>
                        <div class="table-column region-column col-1">
                            <span class="column-label">{{ 'SETTINGS.USERS' | translate }}  {{ region.nbUsers }}</span>
                        </div>
                        <!-- <div class="table-column region-column col-3">
                            <span class="column-label">{{ 'SETTINGS.ADMINS_AREAS' | translate }}</span>
                        </div> -->
                        <div class="table-column actions buttons">
                            <div class="actions-wrapper d-flex align-items-center">
                                <button class="secondary-button" (click)="openPopupArea(region); $event.stopPropagation()" >
                                    <svg-icon src="./icon/edit-pencil.svg"></svg-icon>
                                    {{ 'SETTINGS.MODIFY' | translate }}
                                    <!-- <div class="ps-2">{{ 'SETTINGS.MODIFY' | translate }}</div> -->
                                </button>
                                <button class="primary-button" (click)="openPopupSite(null, region.regionId); $event.stopPropagation()" >
                                    <svg-icon src="./icon/plus.svg"></svg-icon>
                                    {{ 'SETTINGS.NEW_SITE' | translate }}
                                </button>
                                <button class="collapse-toggle ms-auto"
                                (click)="toggleRowDetails(i, region); $event.stopPropagation()">
                                    <img [src]="expandedRowIndex === i ? './icon/arraw-up.svg' : './icon/arraw-down.svg'"
                                    class="arrow-icon" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="collapse-content details-list" *ngIf="expandedRowIndex === i">
                        <ng-container *ngFor="let site of sites; let j = index" >
                            <div class="row-container mb-2">
                                <div class="row" >
                                    <div class="table-column name">
                                        <strong class="column-label">{{ 'SETTINGS.SITE' | translate }}</strong>
                                        <span>{{ site.nom }}</span>
                                    </div>
                                    <div class="table-column name">
                                        <strong class="column-label">{{ 'SETTINGS.COUNTRY' | translate }}</strong>
                                        <span>{{ site.paysName}}</span>
                                    </div>
                                    <div class="table-column name">
                                        <strong class="column-label">{{ 'SETTINGS.USERS' | translate }}</strong>
                                        <span>{{ site.nbUtilisateurs }}</span>
                                    </div>
                                    <!-- <div class="table-column name">
                                        <strong class="column-label">{{ 'SETTINGS.ADMINS_SITES' | translate }}</strong>
                                        <span>{{ site.nbAdmins }}</span>
                                    </div> -->
                                    <div class="table-column name">
                                        <strong class="column-label">{{ 'SETTINGS.BALST_WITHIN_LIMITS' | translate }}</strong>
                                        <!-- <span>{{ site.blastWithinLimits }}</span> -->
                                    </div>
                                    <div class="table-column status">
                                        <strong class="column-label">{{ 'USER.STATUS' | translate }}</strong>
                                        <span class="status-icon" [ngClass]="{ 'active': site.isActif }">
                                            <svg-icon [src]="site.isActif ? './icon/active.svg' : './icon/inactive.svg'"></svg-icon>
                                             <span class="status-text">{{ (site.isActif ? 'SETTINGS.ACTIVE' : 'SETTINGS.INACTIVE') | translate }}</span>
                                          </span>
                                          
                                    </div>
                                    <div class="table-column actions buttons">
                                        <div class="actions-wrapper">
                                            <button class="secondary-button" (click)="goToDetails(site.siteId)" >
                                                {{ 'SETTINGS.DETAILS' | translate }}
                                            </button>
                                        </div>
                                    </div>
                               </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
      </div>
     </div>
</div>